import React from 'react';
import classNames from 'classnames';
import { IStatusBadgeProps } from './';
import './StatusBadge.scss';

export const StatusBadge: React.FC<IStatusBadgeProps> = ({ status, onClick }) => {
    if (!status) {
        return null;
    }
    return (
        <div
            className={classNames('status-badge')}
            style={status?.styles}
            onClick={onClick}
        >
            {status.icon && (
                <span className='status-badge__icon-wrapper'>
                    <status.icon />
                </span>
            )}
            <span
                style={status?.textStyles}
                className='status-badge__status'
            >
                {status?.name}
            </span>
        </div>
    );
};
